import { Route, Routes } from 'react-router-dom'

import { RoutesPath } from 'src/types'

import SignUp from 'src/pages/SignUp'
import Setting from 'src/pages/Setting'
import ServiceMaintenanceHistory from 'src/pages/ServiceMaintenanceHistory'
import ServiceMaintenance from 'src/pages/ServiceMaintenance'
import ServiceContactsHistory from 'src/pages/ServiceContactsHistory'
import ServiceContacts from 'src/pages/ServiceContacts'
import { MyCars } from 'src/pages/MyCars'
import Login from 'src/pages/Login'
import Home from 'src/pages/Home'
import FuelTrackingHistory from 'src/pages/FuelTrackingHistory'
import FuelTracking from 'src/pages/FuelTracking'
import Calendar from 'src/pages/Calendar'
import AutoInfoForm from 'src/pages/AutoInfoForm'
import Analytics from 'src/pages/Analytics'
import ProtectedRoute from 'src/features/ProtectedRoute'
import MainLayout from 'src/features/MainLayout'
import AuthLayout from 'src/features/AuthLayout'

import RegistrationPopup from 'src/components/Modals/PostRegistrationPopup'

const AppRoutes = (): JSX.Element => {
  return (
    <>
      <RegistrationPopup />
      <Routes>
        {/* Auth Routes */}
        <Route
          path={RoutesPath.LOGIN}
          element={
            <AuthLayout>
              <Login />
            </AuthLayout>
          }
        />
        <Route
          path={RoutesPath.SIGNUP}
          element={
            <AuthLayout>
              <SignUp />
            </AuthLayout>
          }
        />

        {/* Protected Routes */}
        <Route
          path={RoutesPath.HOME}
          element={
            <ProtectedRoute>
              <MainLayout>
                <Home />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.FILL_AUTO_INFO}
          element={
            <ProtectedRoute>
              <MainLayout>
                <AutoInfoForm />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.ANALYTICS}
          element={
            <ProtectedRoute>
              <MainLayout>
                <Analytics />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.SETTING}
          element={
            <ProtectedRoute>
              <MainLayout>
                <Setting />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.CALENDAR}
          element={
            <ProtectedRoute>
              <MainLayout>
                <Calendar />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.HOME}
          element={
            <ProtectedRoute>
              <MainLayout>
                <Home />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.CALENDAR}
          element={
            <ProtectedRoute>
              <MainLayout>
                <Calendar />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.ANALYTICS}
          element={
            <ProtectedRoute>
              <MainLayout>
                <Analytics />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.FUEL_TRACKING}
          element={
            <ProtectedRoute>
              <MainLayout>
                <FuelTracking />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.FUEL_HISTORY}
          element={
            <ProtectedRoute>
              <MainLayout>
                <FuelTrackingHistory />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.SERVICE_MAINTENANCE}
          element={
            <ProtectedRoute>
              <MainLayout>
                <ServiceMaintenance />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.SERVICE_MAINTENANCE_HISTORY}
          element={
            <ProtectedRoute>
              <MainLayout>
                <ServiceMaintenanceHistory />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.SERVICE_CONTACTS}
          element={
            <ProtectedRoute>
              <MainLayout>
                <ServiceContacts />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.SERVICE_CONTACTS_HISTORY}
          element={
            <ProtectedRoute>
              <MainLayout>
                <ServiceContactsHistory />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.SETTING}
          element={
            <ProtectedRoute>
              <MainLayout>
                <Setting />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path={RoutesPath.MY_CARS}
          element={
            <ProtectedRoute>
              <MainLayout>
                <MyCars />
              </MainLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  )
}

export default AppRoutes
